import TournamentForm from "@/components/admins/TournamentForm.vue";
import { firestore } from "@/services/firebase";
import { mapGetters } from "vuex";

const defaultTournamentProps = Object.freeze({
  name: "",
  startTime: null,
  baseTimeControl: 15,
  increment: 0,
  playerLimit: 0,
  currentRound: 0,
  totalRounds: 6,
  type: "Swiss",
  privacy: "Private",
  roundMode: "Manual",
  isDeleted: false,
});

const tournamentsRef = firestore.collection("tournaments");

export default {
  components: { TournamentForm },

  data() {
    return {
      isComponentModalActive: false,
      formProps: defaultTournamentProps,
    };
  },

  watch: {
    permission() {
      this.checkPermission();
    },

    tournament() {
      this.checkPermission();
    },
  },

  computed: {
    ...mapGetters({
      permission: "getPermission",
      currentPlayer: "getPlayer",
    }),
  },

  methods: {
    checkPermission() {
      if (!this.permission || !Object.keys(this.permission).length) {
        return;
      }

      if (this.permission.admin) {
        return;
      }

      if (this.$route.params.tournamentId && !this.tournament) {
        return;
      }

      if (this.canEditTournament(this.tournament)) {
        return;
      }

      this.$router.replace({ name: "home" });
    },

    canCreateTournament() {
      return (
        this.permission &&
        (this.permission.admin || this.permission.createTournament)
      );
    },

    canEditTournament(tournament) {
      return (
        this.permission &&
        tournament &&
        (this.permission.admin ||
          (this.permission.createTournament &&
            this.isTournamentOwner(tournament)) ||
          this.$route.name === "AdminTournamentSimulation")
      );
    },

    isTournamentOwner(tournament) {
      return tournament && tournament.ownerId === this.currentPlayer?.user_id;
    },

    createTournament() {
      this.formProps = { ...defaultTournamentProps };
      this.isComponentModalActive = true;
    },

    editTournament(tournament) {
      this.formProps = { id: tournament.id, ...tournament };
      this.isComponentModalActive = true;
    },

    gotoTournament(tournament) {
      this.$router.push(`/admin/tournaments/${tournament.id}`);
    },

    deleteTournament(tournament) {
      this.$buefy.dialog.confirm({
        title: "Deleting Tournamnet",
        message: `Are you sure you want to <b>delete</b> tournament <b>${tournament.name}</b>? This action cannot be undone.`,
        confirmText: "Delete",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          tournamentsRef
            .doc(tournament.id)
            .update({ isDeleted: true })
            .then(this.$buefy.toast.open("Tournamnet deleted!"));
        },
      });
    },
  },
};
